// Copyright (c) 2016 Deere & Company

import DealerTransferHistory from '@deere/cps-it.warranty-model-factory/lib/dealer-transfer-history';
import t from 'tcomb';

const Report = t.list(DealerTransferHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/state/report.js